<template>
    <Modal title="C3PO">
        <template v-slot:body>
            <div class="">Child company consolidation & parent organization</div>
            <div class="build-info">
                <div class="build-info-item">Version: {{ buildInfo.version }}</div>
                <div class="build-info-item">Date: {{ buildInfo.date }}</div>
                <!-- <div class="build-info-item">Job: {{ buildInfo.job }}</div> -->
            </div>
            <div class="debug-mode">
                <span class="debug-mode-label">Debug mode: </span>
                <input type="radio" id="debug-on" v-model="settingsStore.debugMode" :value="true" @change="setDebugMode" />
                <label for="debug-on">On</label>&nbsp;
                <input type="radio" id="debug-off" v-model="settingsStore.debugMode" :value="false" @change="setDebugMode" />
                <label for="debug-off">Off</label>
            </div>
        </template>
        <template v-slot:footer>
            <input type="button" value="Close" class="button" @click="close()" />
        </template>
    </Modal>
</template>

<script setup>
    import { ref } from 'vue';
    import { closeModal } from 'jenesius-vue-modal';
    import Modal from './Modal.vue';
    import build from '@/../build.json';
    import { useSettingsStore } from '@/stores/SettingsStore';

    const buildInfo = ref(build);
    const settingsStore = useSettingsStore();

    function setDebugMode(event) {
        settingsStore.setDebugMode(event.target.value === 'true');
    }

    async function close() {
        closeModal();
    }
</script>

<style scoped>
    .container {
        width: 500px;
    }

    .build-info {
        margin-top: 20px;
        padding: 10px;
        border: 1px solid lightgrey;
    }

    .build-info-item {
        font-family: monospace;
        font-size: 12px;
        color: grey;
    }

    .build-info-item:not(:last-child) {
        margin-bottom: 3px;
    }

    .debug-mode {
        margin-top: 20px;
    }

    .debug-mode-label {
        margin-bottom: 10px;
    }
</style>
